var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isEmpty } from 'renderer/utils';
export var arrayMoveMutate = function (array, from, to) {
    var startIndex = to < 0 ? array.length + to : to;
    var item = array.splice(from, 1)[0];
    array.splice(startIndex, 0, item);
};
export var arrayMove = function (array, from, to) {
    array = array.slice();
    arrayMoveMutate(array, from, to);
    return array;
};
export var changePriorityKey = function (items, targetItem, direction) {
    if (isEmpty(items)) {
        throw new Error('Empty array');
    }
    var targetIndex = items.findIndex(function (item) { return item.id === targetItem.id; });
    var changingIndex = targetIndex + (direction === 'up' ? -1 : +1);
    if (direction === 'up') {
        if (targetIndex < 1) {
            throw new Error('Can not move to up');
        }
    }
    else {
        if (targetIndex + 1 >= items.length) {
            throw new Error('Can not move to down');
        }
    }
    return arrayMove(items, targetIndex, changingIndex).map(function (item, index) { return (__assign(__assign({}, item), { priority: index })); });
};
export var chunkArray = function (arr, size) {
    var i, j, temparray = [], chunk = size;
    for (i = 0, j = arr.length; i < j; i += chunk) {
        temparray.push(arr.slice(i, i + chunk));
    }
    return temparray;
};
export var mapSeries = function (array, iterator) { return __awaiter(void 0, void 0, void 0, function () {
    var length, results, i, _a, _b, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                length = array.length;
                results = new Array(length);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 7]);
                i = 0;
                _c.label = 2;
            case 2:
                if (!(i < length)) return [3 /*break*/, 5];
                _a = results;
                _b = i;
                return [4 /*yield*/, iterator(array[i], i, array)];
            case 3:
                _a[_b] = _c.sent();
                _c.label = 4;
            case 4:
                ++i;
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/, results];
            case 6:
                error_1 = _c.sent();
                throw new Error(error_1);
            case 7: return [2 /*return*/];
        }
    });
}); };
export function isSameArray(arr1, arr2) {
    // 배열의 길이가 다르면 같은 세트가 아니다.
    if (arr1.length !== arr2.length) {
        return false;
    }
    // 각 원소가 두 배열에 모두 포함되어 있는지 검사한다.
    var set1 = new Set(arr1);
    for (var _i = 0, arr2_1 = arr2; _i < arr2_1.length; _i++) {
        var num = arr2_1[_i];
        if (!set1.has(num)) {
            return false;
        }
    }
    // 모든 원소가 포함되어 있으므로 같은 세트이다.
    return true;
}
